export enum JWTDataKeys {
    UPDATE_USER_GROUP = 'jwtData/updateUserGroup',
    CURRENT_USER_GROUP = 'jwtData/currentUserGroup',
    UPDATE_USER_RIGHTS = 'jwtData/updateUserRights',
    UPDATE_JWT_DATA = 'jwtData/updateJwtData',
}
